import { render, staticRenderFns } from "./CharacteristicBox.vue?vue&type=template&id=5e89b368&"
import script from "./CharacteristicBox.vue?vue&type=script&lang=js&"
export * from "./CharacteristicBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports